export default __webpack_public_path__ + "assets/calendar_big-02da3d01adb339b6fa18ab60f343fa97.svg";